import { createSlice } from "@reduxjs/toolkit";
import { Toastify } from "../../../../components/Toaster";
import { errorSideEffects, loadingSideEffects, successSideEffects, updatingSideEffects } from "../..";
import { getOutcomeTrackingState, getRequestTrackingState, MutationTrackingState } from "../../../../services/analytics/tracking";

export interface DuoSecondFactorAuthentication {
  IsEnabled: boolean;
  ClientId?: string;
  ClientSecret?: string;
  APIHost?: string;
}

export interface DuoSecondFactorAuthenticationState {
  Data: DuoSecondFactorAuthentication;
  isLoading: boolean;
  isUpdating: boolean;
  isSuccess: boolean;
  isError: boolean;
  errorMessage: string | null;
}

export const DuoSecondFactorAuthSlice = createSlice({
  name: "duoSecondFactorAuthentication",
  initialState: {
    Data: {},
    isLoading: false,
    isUpdating: false,
    isSuccess: false,
    isError: false,
    errorMessage: null
  },
  reducers: {
    getDuoSecondFactorAuth(state) {
      Object.assign(state, loadingSideEffects);
    },
    getDuoSecondFactorAuthSuccess(state, action) {
      state.Data = action.payload;
      Object.assign(state, successSideEffects);
    },
    getDuoSecondFactorAuthError(state, action) {
      Object.assign(state, errorSideEffects);
      state.errorMessage = action.payload;
    },
    updateDuoSecondFactorAuth(state, action) {
      Object.assign(state, updatingSideEffects, getRequestTrackingState(action));
    },
    updateDuoSecondFactorAuthSuccess(state, action) {
      Object.assign(state, successSideEffects, getOutcomeTrackingState(state as MutationTrackingState, "success"));
      state.Data = action.payload;
      Toastify("success", "Duo Authentication updated successfully");
    },
    updateDuoSecondFactorAuthError(state, action) {
      Object.assign(state, errorSideEffects, getOutcomeTrackingState(state as MutationTrackingState, "error"));
      state.errorMessage = action.payload;
      Toastify("error", action.payload);
    }
  }
});

export const { getDuoSecondFactorAuth, getDuoSecondFactorAuthError, getDuoSecondFactorAuthSuccess, updateDuoSecondFactorAuth, updateDuoSecondFactorAuthError, updateDuoSecondFactorAuthSuccess } =
  DuoSecondFactorAuthSlice.actions;

export default DuoSecondFactorAuthSlice.reducer;
